import { render, staticRenderFns } from "./CotizacionPropuesta.vue?vue&type=template&id=095f3588&"
import script from "./CotizacionPropuesta.vue?vue&type=script&lang=js&"
export * from "./CotizacionPropuesta.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports